import {createVuetify, ThemeDefinition} from "vuetify";
import {aliases, fa} from "vuetify/iconsets/fa";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@fortawesome/fontawesome-pro/css/all.css";
import { getCookie } from "typescript-cookie";
import "@/styles/main.scss";
import {VBtn} from "vuetify/components/VBtn";
import {VCard} from "vuetify/components/VCard";
import {VToolbar} from "vuetify/components/VToolbar";
import {VBreadcrumbs} from "vuetify/components/VBreadcrumbs";

export default (light: ThemeDefinition, dark: ThemeDefinition) => createVuetify({
  components: {
    ...components,
  },
  directives,
  icons: {
    defaultSet: "fa",
    aliases,
    sets: {
      fa
    }
  },
  theme: {
    defaultTheme: getCookie("theme") || "light",
    themes: {
      light,
      dark
    }
  },
  aliases: {
    VBtnPrimary: VBtn,
    VBtnSecondary: VBtn,
    VBtnDelete: VBtn,
    VCardAccountSettings: VCard,
    VCardCreateTenantInstitutionCohort: VCard,
    VTableToolbar: VToolbar,
    VCardOutlined: VCard,
    VPageBreadCrumbs: VBreadcrumbs
  },

  defaults: {
    VPageBreadCrumbs: {
      density: "Compact",
      class: ["pl-0", "caption"]
    },
    VCardOutlined: {
      variant: "outlined",
      class: "bg-white"
    },
    VBtnPrimary: {
      style: { "border-radius": "12px", "min-width": "160px" },
      class: ["v-btn--primary", "text-white", "mr-2"],
      color: "primary",
      elevation: "0"
    },
    VBtnSecondary: {
      style: { "border-radius": "12px", "min-width": "160px" },
      class: [
        "v-btn--secondary",
        "text-primary",
        "bg-grey-lighten-4",
        "bg-grey-lighten-4",
        "mr-2"
      ],
      variant: "outlined"
    },
    VTableToolbar: {
      color: "white",
      class: ["rounded-lg", "border", "mb-4"]
    },
    VBtnDelete: {
      style: { "border-radius": "12px", "min-width": "160px" },
      color: "red",
      class: ["bg-red-darken-2", "text-white"]
    },
    VCheckboxBtn: {
      color: "primary"
    },
    VCardAccountSettings: {
      style: {
        persistent: true,
        "width": "500px",
        "margin": "auto"
      },
    },
    VCardCreateTenantInstitutionCohort: {
      style: {
        persistent: true,
        "width": "500px"
      },
    },
  },
});
